import React from "react";

function Component() {
    return <div>Hello World!</div>
};

export default Component;